import { orderLinesListStyles } from "@insite/content-library/Components/OrderLinesList";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    productDetailDescription: {
        color: "text.main",
        css: css`
            margin: 10px 0;
        `,
    },
    productDetailLink: {
        typographyProps: {
            weight: 700,
        },
        css: css`
            margin: 10px 0;
        `,
    },
};

orderLinesListStyles.orderLineCardInfoGridItem = {
    width: [8, 8, 7, 8, 8],
    css: css`
        @media print {
            max-width: 90%;
            flex-basis: 90%;
            width: 90%;
        }
    `,
};

orderLinesListStyles.orderLineCardImageGridItem = {
    width: 1,
    css: css`
        @media print {
            max-height: 83px;
            max-width: 83px;
            padding: 0;
        }
    `,
};

orderLinesListStyles.orderLineCardAddToListGridItem = {
    width: [2, 2, 3, 2, 2],
    printWidth: 0,
    css: css`
        @media print {
            display: none !important;
        }
    `,
};

orderLinesListStyles.orderLinePriceGridItem = {
    width: [12, 12, 12, 4, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;
    `,
};

orderLinesListStyles.productInfoQtyOrderedGridItem = {
    width: [6, 6, 4, 3, 3],
    printWidth: 4,
    css: css`
        @media print {
            max-width: 33.3%;
            flex-basis: 33.3%;
        }
    `,
};

orderLinesListStyles.productInfoQtyShippedGridItem = {
    width: [6, 6, 4, 3, 3],
    printWidth: 4,
    css: css`
        @media print {
            max-width: 33.3%;
            flex-basis: 33.3%;
        }
    `,
};

orderLinesListStyles.productInfoSubtotalGridItem = {
    width: [12, 12, 4, 6, 6],
    printWidth: 4,
    css: css`
        flex-direction: column;
        @media print {
            max-width: 33.3%;
            flex-basis: 33.3%;
        }
    `,
};

orderLinesListStyles.productInfoTotalsGridItem = {
    width: [12, 12, 12, 8, 8],
    printWidth: 8,
};
